module.exports = __webpack_public_path__ + "img/header_language.a444a920.svg";